import { format } from 'date-fns';

export const formatDate = (date, _format) => {
  const d = new Date(date);
  return format(new Date(d.getFullYear(), d.getMonth(), d.getDate()), _format);
};

export const applyOffest = (date, weeks, months, years) => {
  const d = new Date(date);
  const year = d.getFullYear();
  const month = d.getMonth();
  const day = d.getDate();
  return new Date(year + years, month + months, day + weeks * 7);
};
